import { render, staticRenderFns } from "./SendToLrModal.vue?vue&type=template&id=57983b7b"
import script from "./SendToLrModal.vue?vue&type=script&lang=ts"
export * from "./SendToLrModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports